const HISAR_12_MAR_2025 = () => {
    return(
        <>
        <div className="container lead yatra-release-content my-5">
                <h4 className="text-center mb-5">भगवा त्रिशूल यात्रा हिसार पहुंची, श्रद्धालुओं ने भव्य स्वागत कर किया धर्म जागरण का आह्वान </h4>
                <div className="border shadow rounded-4 p-4">
                    <p>
                        <span className="fw-bold">हिसार, 12 मार्च 2025 :</span>अंतर्राष्ट्रीय मंदिर प्रबंधक परिषद (IMPC) द्वारा आयोजित ऐतिहासिक भगवा त्रिशूल यात्रा आज हरियाणा के धार्मिक नगरी हिसार पहुंची, जहां श्रद्धालुओं ने यात्रा का भव्य स्वागत किया। यह यात्रा 120 त्रिशूलों के साथ सनातन धर्म के जागरण और मंदिरों के पुनरुद्धार का संदेश लेकर आगे बढ़ रही है। हजारों भक्तों ने भगवा ध्वज लहराते हुए जयघोष किया और शिव भक्ति के रंग में रंगे हुए यात्रा का अभिनंदन किया।
                    </p>
                    <p>
                    यात्रा का पहला पड़ाव बंभोरी में हुआ, जहां श्रद्धालुओं ने माता के दर्शन किए और भव्य अभिषेक संपन्न किया। इसके पश्चात यात्रा सिद्धपीठ कोथ कला पहुंची, जहां श्रद्धालुओं ने बाबा के दर्शन कर धर्म जागरण का संकल्प लिया। कोथ खुर्द, नाडा, किन्नर, खेड़ी जलाब, राखी गढ़ी और बुढ़ाना में भी यात्रा का श्रद्धा और भक्ति भाव से स्वागत किया गया। हर जगह भजन-कीर्तन, शिव तांडव स्तोत्र और जयघोष गूंजते रहे। अंत में यात्रा नारनोद पहुंची, जहां रात्रि विश्राम किया गया।
                    </p>
                    <p className="fw-bold">
                    सनातन संस्कृति के पुनर्जागरण का अभियान
                    </p>
                    <p>
                    भगवा त्रिशूल यात्रा केवल एक धार्मिक आयोजन नहीं, बल्कि यह सनातन संस्कृति के पुनर्जागरण का विराट अभियान है। 12 ज्योतिर्लिंग, 12 शक्तिपीठ और चार धामों के त्रिशूलों का महासंगम बन चुकी यह यात्रा प्रयागराज के महाकुंभ में मौनी अमावस्या से 31 दिनों तक 108 त्रिशूलों के नियमित अभिषेक के बाद अब 120 त्रिशूलों के साथ दिल्ली की ओर अग्रसर है।
                    </p>
                    <p>
                    IMPC के राष्ट्रीय महामंत्री एवं AVPL इंटरनेशनल के चेयरमैन श्री दीप सिहाग सिसाय ने कहा, "भगवा त्रिशूल यात्रा केवल आस्था का प्रतीक नहीं, बल्कि यह हमारी संस्कृति और धर्म की पुनर्स्थापना का संकल्प है। हम बाबा रामसर तीर्थ, सिद्धपीठों और अन्य धार्मिक स्थलों तक पहुंचकर अपनी विरासत को पुनर्जीवित कर रहे हैं। यह यात्रा सनातन मूल्यों को समाज से जोड़ने का सशक्त माध्यम बन रही है।"
                    </p>
                    <p>IMPC के राष्ट्रीय महामंत्री संगठन डॉ. नवीन नैन ने कहा, "भगवा त्रिशूल यात्रा भारत की आध्यात्मिक धरोहर को पुनर्जीवित करने का एक ऐतिहासिक अभियान है। हमारी युवा पीढ़ी को सनातन संस्कृति और गौरवशाली परंपराओं से जोड़ने का यह एक प्रभावी माध्यम है। यह यात्रा भक्ति और श्रद्धा के साथ-साथ धर्म जागरण का संदेश लेकर आगे बढ़ रही है।"</p>
                    <p>हिसार में यात्रा को अपार श्रद्धा और भक्ति भाव से स्वागत मिला। हजारों श्रद्धालुओं की उपस्थिति में यह यात्रा अपने अगले पड़ाव की ओर बढ़ रही है। इस यात्रा का समापन दिल्ली में एक ऐतिहासिक आयोजन के साथ होगा, जहां सनातन संस्कृति के पुनरुद्धार और धर्म जागरण का संदेश पूरी दुनिया में पहुंचेगा।</p>
                    <p className="fw-bold">हर हर महादेव! जय श्रीराम!</p>
                    <p>
                    संपर्क 
                    </p>
                    <p>अंजुल त्यागी </p>
                    <p>प्रेस सचिव, अंतरराष्ट्रीय मंदिर प्रबंधक परिषद् (IMPC)</p>
                    <p>9736373839</p>
                </div>
        </div>
        
        
        
        
        </>
    )

}

export default HISAR_12_MAR_2025;